import moment from 'moment'
import React from 'react'
import DatePicker, {registerLocale} from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import * as dateLocale from 'date-fns/locale'
import "react-datepicker/dist/react-datepicker.css"

class DateInput extends React.Component {
  render () {
    return (
      <div className="date-input" onClick={this.props.onClick}>
        {this.props.value}
      </div>
    )
  }
}

registerLocale("en", dateLocale.enUS)
registerLocale("es", dateLocale.es)

export function Picker(props) {
    
    return (
        <DatePicker
          customInput={<DateInput />}
          selected={props.date}
          onChange={props.setDate}
          minDate={props.minDate}
          maxDate={props.maxDate}
          locale={props.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
          popperPlacement="auto-left"
          popperModifiers={{
            preventOverflow: {
              enabled: true,
              escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
              boundariesElement: 'viewport'
            }
          }}
        />
    )
  }

export {DatePicker, Picker as default}
